/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { View, Text, Tooltip, Actionable } from '@az/starc-ui';
import Image from '@/components/NextImage';
import { useLocale } from '@/hooks/useLocale';
import { useLabels } from '@/hooks/useLabels';
import { countryCodes } from '@/constants/locale';
import styles from './styles.module.scss';

const labelMap = {
  bvAuthenticReviews: 'label_reviews_BazaarvoiceAuthenticReviews',
  authenticReviews: 'label_reviews_AuthenticReviews',
  firstTextBVTooltip: 'label_reviews_TheseReviewsAreManagedByBazaarvoice',
  secondTextBVTooltip: 'label_reviews_LearnMoreAboutThe',
  urlBVTooltip: 'label_reviews_BazaarvoiceAuthenticityPolicy',
  infoBV: 'label_reviews_InfoAboutBazaarvoice',
};

const bvTrustMarkEn = 'https://www.autozone.com/cdn/icons/az_icons/bvTrustMarkEn.png';
const bvTrustMarkEs = 'https://www.autozone.com/cdn/icons/az_icons/bvTrustMarkEs.png';

export const BVTrustMark = () => {
  const locale = useLocale();
  const labels = useLabels(labelMap);
  const isMx = locale === countryCodes.mx;

  return (
    <View className={styles.bvTrustMark}>
      <Image
        alt={labels.bvAuthenticReviews}
        src={isMx ? bvTrustMarkEs : bvTrustMarkEn}
        width={368}
        height={64}
        className={styles.image}
      />
      <Tooltip
        headerText={labels.authenticReviews}
        buttonTitle={labels.infoBV}
        svgSize={6}
        placement="bottom"
      >
        <View className={styles.bvTooltip}>
          <Text color="500" className={styles.textTooltip}>
            {labels.firstTextBVTooltip} {labels.secondTextBVTooltip}
            <Actionable
              href="https://www.bazaarvoice.com/legal/authenticity-policy/"
              className={styles.bvLink}
            >
              {labels.urlBVTooltip}
            </Actionable>
          </Text>
        </View>
      </Tooltip>
    </View>
  );
};
